import { isAxiosError } from "axios";

import { TOKEN_BUDGET_EXCEEDED_ERROR_CODE } from "../constants/chat";

const HTTP_TOO_MANY_REQUESTS = 429;

const readErrorCode = (data: unknown): unknown => {
  if (typeof data !== "object" || data === null || !("errorCode" in data)) {
    return null;
  }

  return data.errorCode;
};

// NOTE: NSAI-5732 — "the usage limit is spent" is a different kind of failure
// from "this request was bad", and a screen that cannot tell them apart says
// the wrong thing: probe generation reported a broken document for a refusal
// the document had nothing to do with. The status alone is not enough to
// separate them — a 429 is also what throttling answers with — so the decisive
// signal is the `errorCode` TokenBudgetExceededException puts on the body.
//
// Deliberately not probe-specific: NSAI-5712 is the same confusion on a manual
// agent run, and any caller that renders a rejection can ask this question.
export const isTokenBudgetExceededError = (error: unknown): boolean => {
  if (!isAxiosError(error)) return false;

  const { response } = error;
  if (!response || response.status !== HTTP_TOO_MANY_REQUESTS) return false;

  return readErrorCode(response.data) === TOKEN_BUDGET_EXCEEDED_ERROR_CODE;
};
